import {Loading} from '@components/common/loading/loading'
import {useSyncEvent} from '@containers/hooks'
import {observer} from 'mobx-react-lite'
import React, {useEffect, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {DataObjectId} from 'yougile-model'
import {Filter} from './components/filter'
import {ShowMore} from './components/show-more'
import {
  TaskEventLogContext,
  TaskEventLogStore,
  useTaskEventLogStore
} from './task-event-log-store'
import {TaskEventLogTiles} from './task-event-log-tiles'

const TwCenter = tw.div`
  flex
  justify-center
  text-third-old
  mt-64
`

interface Props {
  taskId: DataObjectId
}

export const TaskEventLog = observer(({taskId}: Props) => {
  const [store] = useState(() => new TaskEventLogStore())
  return (
    <TaskEventLogContext.Provider value={store}>
      <TaskEventLogBase taskId={taskId} />
    </TaskEventLogContext.Provider>
  )
})

const TaskEventLogBase = observer(({taskId}: Props) => {
  const [state, store] = useTaskEventLogStore()

  useEffect(() => {
    store.updateStats(taskId)
  }, [state.itemsToLoad, store.activeFilter, taskId])

  useSyncEvent(
    'current',
    {debounceTime: 1000, filter: taskId},
    () => store.updateStats(taskId),
    [taskId]
  )

  return (
    <>
      <Filter initialFilter={state.filter} />
      <TaskEventLogTiles />
      <ShowMore />
      {!state.stats && (
        <TwCenter>
          <Loading />
        </TwCenter>
      )}
      {state.stats && Object.keys(store.events).length === 0 && (
        <TwCenter>{Lang.msg.statsTimeline.empty}</TwCenter>
      )}
    </>
  )
})
